import { Select } from "antd";
import { useMemo } from "react";

const UiSelect = ({
    onChange,
    onSearch,
    label,
    required = false,
    disabled = false,
    options,
    style,
    placeholder,
    mode,
    ...restProps
}) => {
    const dropdownWidth = useMemo(() => {
        if (!options?.length) return "auto";
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        context.font = "16px Arial";
        const maxLengthOption = options?.reduce((longest, option) => {
            const text = option?.value || "";
            const width = context.measureText(text).width;
            return Math.max(longest, width);
        }, 0);
        return `${maxLengthOption + 30}px`;
    }, [options]);

    const newFilterOption = (input, option) => {
        if (option?.value) {
            return (option?.value)
                ?.toLowerCase()
                ?.includes(input?.toLowerCase());
        }
    };

     const handleChange = (selectedValues, selectedOptions) => {
        if (mode === "multiple") {
            const selectedKeys = selectedOptions?.map((option) => option?.key);
            if (onChange) {
                onChange(selectedKeys, selectedValues, selectedOptions);
            }
        } else {
            const selectedKey = selectedOptions?.key;
            if (onChange) {
                onChange(selectedKey, selectedOptions?.gst, selectedValues, selectedOptions);
            }
        }
    };

    const handleSearch = (selectedOption) => {
        if (onSearch) {
            onSearch(selectedOption?.value);
        }
    };


    return <div>
        {label && <div style={{ padding: "10px" }}>
            <label>
                {label} {required && <span style={{ color: 'red' }}>*</span>}
            </label>
        </div>}
        <div style={{ padding: "0px" }}>
            <Select
                showSearch
                allowClear
                onChange={handleChange}
                onSearch={handleSearch}
                options={options}
                style={style}
                placeholder={placeholder || "Select"}
                disabled={disabled}
                mode={mode}
                dropdownStyle={{ minWidth: dropdownWidth }}
                filterOption={newFilterOption}
                {...restProps}
            />
        </div>
    </div>
};
export default UiSelect